import { MetadataType } from 'pages/create-brand/create-brand-metadata/types';
import { createContext, useContext } from 'react';
import { CreateShopFormType, ShopPolygonType } from 'utils/types';

export type EditShopContextType = {
  shopDetails: CreateShopFormType;
  setShopDetails: (k: CreateShopFormType) => void;
  disabled: boolean;
  polygons: ShopPolygonType[];
  setPolygons: (k: ShopPolygonType[]) => void;
  setDisabled: (k: boolean) => void;
  keywordsList: MetadataType[];
  descriptiveMetadataList: MetadataType[];
  businessMetadataList: MetadataType[];
  setKeywordsList: (k: MetadataType[]) => void;
  setDescriptiveMetadataList: (k: MetadataType[]) => void;
  setBusinessMetadataList: (k: MetadataType[]) => void;
  createMetadata: (name: string, type: 'brand' | 'descriptive' | 'business') => Promise<void>;
  loadingShop: boolean;
  getShopById: () => void;
};

export const EditShopContext = createContext({} as EditShopContextType);

const useEditShopContext = () => {
  const context = useContext(EditShopContext);
  return context;
};

export default useEditShopContext;
